//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import router from "../../router";
export default {
  name: 'mineNumberArr',
  data: function data() {
    return {
      mineNumberArr: {
        id: '',
        ip: '',
        isCoalWashDataUpload: 0,
        isCoalWashDataUploadLog: 0,
        isCoalWashDataReview: 0,
        reportGenerationTime: 16,
        password: '',
        port: '',
        username: ''
      },
      isCoalWashDataUpload: true,
      isCoalWashDataUploadLog: true,
      isCoalWashDataReview: true,
      balanceArr: [],
      ReportGenerationTime: [{
        name: '0点',
        value: 0
      }, {
        name: '1',
        value: 1
      }, {
        name: '2',
        value: 2
      }, {
        name: '3',
        value: 3
      }, {
        name: '4',
        value: 4
      }, {
        name: '5',
        value: 5
      }, {
        name: '6',
        value: 6
      }, {
        name: '7',
        value: 7
      }, {
        name: '8',
        value: 8
      }, {
        name: '9',
        value: 9
      }, {
        name: '10',
        value: 10
      }, {
        name: '11',
        value: 11
      }, {
        name: '12',
        value: 12
      }, {
        name: '13',
        value: 13
      }, {
        name: '14',
        value: 14
      }, {
        name: '15',
        value: 15
      }, {
        name: '16',
        value: 16
      }, {
        name: '17',
        value: 17
      }, {
        name: '18',
        value: 18
      }, {
        name: '19',
        value: 19
      }, {
        name: '20',
        value: 20
      }, {
        name: '21',
        value: 21
      }, {
        name: '22',
        value: 22
      }, {
        name: '23',
        value: 23
      }]
    };
  },
  created: function created() {
    this.getSystemInfo();
  },
  methods: {
    getSystemInfo: function getSystemInfo() {
      var _this = this;

      var serach = {};
      this.$zybhttp.get('Business/GetCoalWashDataConfigInfor', {}).then(function (res) {
        if (res.data.status == 0) {
          var d = res.data;
          _this.version = d.msg;
          _this.mineNumberArr.id = d.data.list[0].id;
          _this.mineNumberArr.ip = d.data.list[0].ip;
          _this.mineNumberArr.port = d.data.list[0].port;
          _this.mineNumberArr.username = d.data.list[0].userName;
          _this.mineNumberArr.password = d.data.list[0].passWord;
          _this.mineNumberArr.isCoalWashDataUpload = d.data.list[0].isCoalWashDataUpload;
          _this.mineNumberArr.isCoalWashDataUploadLog = d.data.list[0].isCoalWashDataUploadLog;
          _this.mineNumberArr.isCoalWashDataReview = d.data.list[0].isCoalWashDataReview;
          _this.isCoalWashDataUpload = d.data.list[0].isCoalWashDataUpload == 1 ? true : false;
          _this.isCoalWashDataUploadLog = d.data.list[0].isCoalWashDataUploadLog == 1 ? true : false;
          _this.isCoalWashDataReview = d.data.list[0].isCoalWashDataReview == 1 ? true : false;
        } else {
          _this.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this.$notify.error('网络异常！获取列表失败！');
      });
    },
    saveEdit: function saveEdit() {
      var _this2 = this;

      this.$refs['mineNumberArr'].validate(function (valid) {
        if (valid) {
          _this2.$zybhttp.post('SystemInfo/SetCoalWashDataConfigInfor', _this2.mineNumberArr).then(function (res) {
            if (res.data.status == 0) {
              _this2.$notify.success('修改成功');

              _this2.getSystemInfo();
            } else {
              _this2.$notify.error('修改失败');
            }
          }).catch(function (err) {
            return _this2.$notify.error('网络异常！修改失败');
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    changeWashDataUpload: function changeWashDataUpload() {
      var _this3 = this;

      this.mineNumberArr.isCoalWashDataUpload = this.isCoalWashDataUpload ? 1 : 0;
      this.$zybhttp.post('SystemInfo/SetCoalWashDataConfigInfor', this.mineNumberArr).then(function (res) {
        if (res.data.status == 0) {
          _this3.$notify.success('修改成功');

          _this3.getSystemInfo();
        } else {
          _this3.$notify.error('修改失败');
        }
      }).catch(function (err) {
        return _this3.$notify.error('网络异常！修改失败');
      });
    },
    changeWashDataUploadLog: function changeWashDataUploadLog() {
      var _this4 = this;

      this.mineNumberArr.isCoalWashDataUploadLog = this.isCoalWashDataUploadLog ? 1 : 0;
      this.$zybhttp.post('SystemInfo/SetCoalWashDataConfigInfor', this.mineNumberArr).then(function (res) {
        if (res.data.status == 0) {
          _this4.$notify.success('修改成功');

          _this4.getSystemInfo();
        } else {
          _this4.$notify.error('修改失败');
        }
      }).catch(function (err) {
        return _this4.$notify.error('网络异常！修改失败');
      });
    },
    UpLog: function UpLog() {
      this.$router.push('CoalWashDataUploadRecord');
    }
  }
};